import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/login/1.jpg'
import _imports_1 from '@/assets/images/logo/logo.png'
import _imports_2 from '@/assets/images/logo/logo_dark.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xl-5 p-0" }
const _hoisted_4 = { class: "login-card login-dark" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = { class: "login-main" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-input position-relative" }
const _hoisted_10 = ["type"]
const _hoisted_11 = { class: "form-group mb-0" }
const _hoisted_12 = { class: "link" }
const _hoisted_13 = { class: "social mt-4" }
const _hoisted_14 = { class: "btn-showcase" }
const _hoisted_15 = {
  class: "btn btn-light",
  href: "https://www.linkedin.com/login",
  target: "_blank"
}
const _hoisted_16 = {
  class: "btn btn-light",
  href: "https://twitter.com/login?lang=en",
  target: "_blank"
}
const _hoisted_17 = {
  class: "btn btn-light",
  href: "https://www.facebook.com/",
  target: "_blank"
}
const _hoisted_18 = { class: "mt-4 mb-0 text-center" }

import { ref } from "vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'loginValidation',
  setup(__props) {

let email = ref<string>("")
let formSubmitted = ref<boolean>(false)
let emailError = ref<boolean>(false)
let emailFieldClasses = ref<string>("")
let errors = ref([])
let password = ref<string>("")
let passwordError = ref<boolean>(false)
let type = ref<string>('password')
function validate() {
    formSubmitted.value = true;
    errors.value = [];
    if (email.value.length < 10 || email.value.search("@") == -1) {
        emailError.value = true;
        errors.value.push();
    } else {
        emailError.value = false;
        errors.value.push();
    }
    if (password.value.length < 7) {
        passwordError.value = true;

    } else {
        passwordError.value = false;
    }
}
function showPassword() {
    if (type.value === 'password') {
        type.value = 'text';
    } else {
        type.value = 'password';
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "col-xl-7 order-1 b-center bg-size",
        style: _normalizeStyle({ backgroundImage: 'url(' + require('@/assets/images/login/1.jpg') + ')', })
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("img", {
          class: "bg-img-cover bg-center d-none",
          src: _imports_0,
          alt: "looginpage"
        }, null, -1)
      ]), 4),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("a", _hoisted_5, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("img", {
                      class: "img-fluid for-light",
                      src: _imports_1,
                      alt: "looginpage"
                    }, null, -1),
                    _createElementVNode("img", {
                      class: "img-fluid for-dark",
                      src: _imports_2,
                      alt: "looginpage"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("form", {
                class: "theme-form",
                novalidate: "",
                onSubmit: _withModifiers(validate, ["prevent"])
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("h4", null, "Sign in to account", -1)),
                _cache[15] || (_cache[15] = _createElementVNode("p", null, "Enter your email & password to login", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "col-form-label" }, "Email Address", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["form-control", _unref(formSubmitted) ? _unref(emailError) ? 'is-invalid' : 'is-valid' : '']),
                    id: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : email = $event)),
                    type: "email",
                    required: "",
                    placeholder: "Test@gmail.com"
                  }, null, 2), [
                    [_vModelText, _unref(email)]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "col-form-label" }, "Password", -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass(["form-control", _unref(formSubmitted) ? _unref(passwordError) ? 'is-invalid' : 'is-valid' : '']),
                      type: _unref(type),
                      name: "login[password]",
                      required: "",
                      placeholder: "*********",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : password = $event))
                    }, null, 10, _hoisted_10), [
                      [_vModelDynamic, _unref(password)]
                    ]),
                    _createElementVNode("div", { class: "show-hide" }, [
                      _createElementVNode("span", {
                        class: "show",
                        onClick: showPassword
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "checkbox p-0" }, [
                    _createElementVNode("input", {
                      id: "checkbox1",
                      type: "checkbox"
                    }),
                    _createElementVNode("label", {
                      class: "text-muted",
                      for: "checkbox1"
                    }, "Remember password")
                  ], -1)),
                  _createElementVNode("a", _hoisted_12, [
                    _createVNode(_component_router_link, { to: "/authentication/forget_password" }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" Forgot password?")
                      ])),
                      _: 1
                    })
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-end mt-3" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-block w-100",
                      type: "submit"
                    }, "Sign in")
                  ], -1))
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("h6", { class: "text-muted mt-4 or" }, "Or Sign in with", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("a", _hoisted_15, [
                      _createVNode(_component_vue_feather, {
                        class: "txt-linkedin",
                        type: "linkedin"
                      }),
                      _cache[9] || (_cache[9] = _createTextVNode(" LinkedIn "))
                    ]),
                    _createElementVNode("a", _hoisted_16, [
                      _createVNode(_component_vue_feather, {
                        class: "txt-twitter",
                        type: "twitter"
                      }),
                      _cache[10] || (_cache[10] = _createTextVNode("twitter"))
                    ]),
                    _createElementVNode("a", _hoisted_17, [
                      _createVNode(_component_vue_feather, {
                        class: "txt-fb",
                        type: "facebook"
                      }),
                      _cache[11] || (_cache[11] = _createTextVNode("facebook"))
                    ])
                  ])
                ]),
                _createElementVNode("p", _hoisted_18, [
                  _cache[13] || (_cache[13] = _createTextVNode("Don't have account?")),
                  _createVNode(_component_router_link, {
                    class: "ms-2",
                    to: "/auth/register"
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("Create Account")
                    ])),
                    _: 1
                  })
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})